import React from 'react';
import { Box, Skeleton, Grid, Card, CardContent } from '@mui/material';

export const SkeletonCard = () => (
    <Card sx={{ borderRadius: '24px', height: '100%', boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
        <Skeleton variant="rectangular" height={200} sx={{ borderRadius: '24px 24px 0 0' }} />
        <CardContent sx={{ p: 3 }}>
            <Skeleton variant="text" width="60%" height={24} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={20} sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="rectangular" width="40%" height={32} sx={{ borderRadius: '8px' }} />
            </Box>
        </CardContent>
    </Card>
);

export const SkeletonDashboard = () => (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
                <Skeleton variant="text" width={250} height={40} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={150} height={20} />
            </Box>
            <Skeleton variant="circular" width={56} height={56} />
        </Box>
        
        <Grid container spacing={3} sx={{ mb: 4 }}>
            {[1, 2, 3, 4].map((i) => (
                <Grid item xs={12} sm={6} md={3} key={i}>
                    <Card sx={{ p: 2, borderRadius: '16px' }}>
                        <Skeleton variant="circular" width={40} height={40} sx={{ mb: 2 }} />
                        <Skeleton variant="text" width="80%" height={30} />
                        <Skeleton variant="text" width="50%" />
                    </Card>
                </Grid>
            ))}
        </Grid>

        <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
        <Grid container spacing={3}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                    <SkeletonCard />
                </Grid>
            ))}
        </Grid>
    </Box>
);

export const SkeletonListing = () => (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton variant="text" width={200} height={48} />
            <Skeleton variant="rectangular" width={150} height={48} sx={{ borderRadius: '16px' }} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '16px', mb: 4 }} />
        <Grid container spacing={4}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                    <SkeletonCard />
                </Grid>
            ))}
        </Grid>
    </Box>
);
